import React from "react";
import { useNavigate } from "react-router-dom";
import "./Product.scss";
import StarRating from "../../SingleProduct/StarRating";
import { Context } from "../../../utils/context";
import { useContext } from "react";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../../utils/feature/wishlistSlice";
import { useDispatch } from "react-redux";

const Product = ({ id, name, images, price, product }) => {
  const {
    cartCount,
    showCart,
    setShowCart,
    showWishlist,
    setShowWishlist,
    handleAddTowishlist,
    handleAddToCart,
  } = useContext(Context);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const wishlist = () => {
    setShowWishlist(true);
    dispatch(addToWishlist(product));
  };

  const quantity = 1;
  return (
    <div className="product-card relative  mr-2 lg:mr-8   ">
      <div className="  opacity-0 hover:opacity-100  absolute -bottom-0  h-full w-full left-0 z-50  flex   justify-center   gap-3 pt-24  ">
        <div
          onClick={() => {
            wishlist();
          }}
          className=" bg-white   w-10 h-10 flex justify-center items-center hover:bg-red-500 hover:text-white text-bold  shadow-2xl text-xl "
        >
          <ion-icon name="heart-outline"></ion-icon>
        </div>
        <div
          onClick={() => navigate("/product/" + id)}
          className=" bg-white   w-10 h-10 flex justify-center items-center hover:bg-red-500 hover:text-white text-bold  shadow-2xl text-xl "
        >
          <ion-icon name="search-outline"></ion-icon>
        </div>
        <div
          onClick={() => handleAddToCart(product, quantity)}
          className=" bg-white    w-10 h-10 flex justify-center items-center hover:bg-red-500 hover:text-white text-bold  shadow-2xl text-xl "
        >
          <ion-icon name="cart-outline"></ion-icon>{" "}
        </div>

        <div className=" absolute bottom-0 flex gap-2 left-0  py-1  bg-white w-full     ">
          {product &&
            product?.images?.images?.map((color, index) => (
              <span key={index} className="mr-2">
                <div
                  style={{ backgroundColor: `${color?.color}` }}
                  className={`h-6 w-6 rounded-full shadow-black  shadow-sm cursor-pointer`}
                  onClick={() =>
                    navigate(`/product/${product._id}?color=${color?.color}`, {
                      state: { color },
                    })
                  }
                ></div>
              </span>
            ))}
        </div>
      </div>

      <div className="thumbnail      overflow-hidden  border-2   bg-black/20; ">
        <img
          className=" w-[100%]  h-full filter    object-contain   object-top   "
          src={product?.images?.featuredImage?.src}
        />
      </div>

      <div className="prod-detail space-y-1 md:text-xl">
        <div
          className="name line-clamp-2 text-sm font-bold z-50 relative"
          onClick={() => navigate("/product/" + product._id)}
        >
          {product?.name}
        </div>
        <div className="pric text-[16px] font-bold text-red-500">
          &#8377;{product?.images[0]?.sizesData[0]?.price}
          <span className="pric t line-through text-xs text-gray-400 mx-2">
            &#8377;{product?.images[0]?.sizesData[0]?.originalPrice}
          </span>
          <span className=" text-green-700 font-bold text-sm md:text-[10px] ">
            15 % Off
          </span>
        </div>
        <div className=" ">
          <span className="text-yellow-500">
            <ion-icon name="star"></ion-icon>
          </span>
          <span className="text-yellow-500">
            <ion-icon name="star"></ion-icon>
          </span>
          <span className="text-yellow-500">
            <ion-icon name="star"></ion-icon>
          </span>
          <span className="text-yellow-500">
            <ion-icon name="star"></ion-icon>
          </span>
          <span className="text-yellow-500">
            <ion-icon name="star-half"></ion-icon>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Product;
